<section class="email-submitted-page" *ngIf="pageData">
  <div class="content-wrapper">
    <p class="welcome">{{ pageData.title }}</p>
    <h1 class="thanks">{{ pageData.sub_title }}</h1>
    <h3 class="personalised">
      {{ pageData.account_message }}
    </h3>
    <p>
      {{ pageData.check_inbox_message }}
    </p>
  </div>
  <ng-container *ngIf="pageData?.web_image?.data?.attributes?.url">
    <div class="image-wrapper">
      <img
        src="{{ pageData.web_image.data?.attributes?.url }}"
        alt="Background image"
        class="web-image"
      />
    </div>
  </ng-container>
</section>
